import { Policies } from "../policies";

export const policiesRoutes = [
  {
    path: "/policies",
    Component: Policies,
    exact: true,
    isPrivate: false,
  },
];
